import './blog.css';

import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

import axios from 'axios';


export default function Blog() {
    const [expandedAccordion, setExpandedAccordion] = useState(null);
    const [blogs, setBlogs] = useState([]);
    const [categories, setCategories] = useState([]);

    const apiUrl = "https://partywitty.com/master/APIs/Web/getBlogsList";
    const categoriesApiUrl = "https://partywitty.com/master/APIs/Web/getBlogCategroy";
    const imgUrlPrefix = "https://partywitty.com/master/assets/uploads/";

    useEffect(() => {

        axios.get(apiUrl)
            .then(response => {
                if (response.data && response.data.status) {
                    setBlogs(response.data.data);
                } else {
                    console.error("Failed to fetch blog data:", response.data.msg);
                }
            })
            .catch(error => {
                console.error("Error fetching blog data:", error);
            });


        axios.get(categoriesApiUrl)
            .then(response => {
                if (response.data && response.data.status) {
                    setCategories(response.data.data);
                } else {
                    console.error("Failed to fetch categories data:", response.data.msg);
                }
            })
            .catch(error => {
                console.error("Error fetching categories data:", error);
            });
    }, []);

    const handleAccordionChange = (panel) => (event, isExpanded) => {
        setExpandedAccordion(isExpanded ? panel : null);
    };
    function truncateText(htmlString, maxLength) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');
        const textContent = doc.body.textContent || '';

        const words = textContent.trim().split(/\s+/);

        if (words.length <= maxLength) {
            return textContent;
        }

        const truncated = words.slice(0, maxLength).join(' ') + '...';
        return truncated;
    }


    const [visibleCount, setVisibleCount] = useState(3);
    const loaderRef = useRef(null);


    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setVisibleCount((prev) => prev + 3); // Load next 6
                }
            },
            { threshold: 1 }
        );

        if (loaderRef.current) {
            observer.observe(loaderRef.current);
        }

        return () => {
            if (loaderRef.current) observer.unobserve(loaderRef.current);
        };
    }, []);






    return (
        <div className='blog-page'>
            <div className='blog-banner-page'>
                <h2>Blog</h2>
            </div>
            <div className='aboutus'>

                <div className="blog-grid-container">
                    {blogs.length === 0 ? (
                        <>
                            {[...Array(6)].map((_, i) => (
                                <div className="blog-shimmer-card" key={i}>
                                    <div className="blog-shimmer-image blog-shimmer"></div>
                                    <div className="blog-shimmer-content">
                                        <div className="blog-shimmer-title blog-shimmer"></div>
                                        <div className="blog-shimmer-date blog-shimmer"></div>
                                        <div className="blog-shimmer-text blog-shimmer"></div>
                                        <div className="blog-shimmer-read blog-shimmer"></div>
                                    </div>
                                </div>
                            ))}
                        </>

                    ) :
                        (blogs.slice(0, visibleCount).map(blog => (
                            <>
                                <Link
                                    to={`/blogs/${blog.title.replace(/\s+/g, '-').toLowerCase()}`}
                                    key={blog.title}
                                    className="blog-card"
                                >
                                    <div className="blog-card-category">{blog.category}</div>

                                    <div className="blog-card-image">
                                        <img src={imgUrlPrefix + blog.img} alt={blog.title} />
                                    </div>

                                    <div className="blog-card-content">
                                        <h3 className="blog-card-title">
                                            {blog.title.length > 20 ? blog.title.slice(0, 30) + '...' : blog.title}
                                        </h3>
                                        <p className="blog-card-date">{new Date(blog.date_added).toDateString()}</p>
                                        <div
                                            className="blog-card-description"
                                            dangerouslySetInnerHTML={{ __html: truncateText(blog.des, 5) }}
                                        />
                                        <p className="blog-card-readmore">Read more...</p>
                                    </div>
                                </Link>
                            </>
                        )))}
                    <div ref={loaderRef} style={{ height: "1px" }} />
                </div>

            </div>
        </div>
    );
}





